import axios from "axios";

export async function requestBackendReportExport({
  clientId,
  userPlatform,
  reportType,
  totalCount,
  triggeredBy,
  queryBody,
  frontendConfig,
}) {
  const exportUrl = `${process.env.REACT_APP_ADS_API}/client/${clientId}/reports:export?source=${userPlatform}`;
  const exportPayload = {
    report_type: reportType,
    total_count: totalCount,
    triggered_by: triggeredBy,
    query: {
      body: queryBody,
    },
    frontend_config: frontendConfig,
  };

  await axios.post(exportUrl, exportPayload, {
    headers: { "Content-Type": "application/json" },
  });
}
